import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiPlus, FiMinus, FiHelpCircle } from 'react-icons/fi';

const faqs = [
  {
    q: "How do I initialize my first Skill Path?",
    a: "Navigate to the 'Skill Map' sector. From there, you can select a domain (e.g., Frontend Engineering) and the system will generate a custom trajectory based on your current level and energy capacity."
  },
  {
    q: "Is the data in this demo persistent?",
    a: "This demo uses localized synaptic mock-data. While you can interact with UI elements like filters and state toggles, progress is not saved to a remote server in this specific environment."
  },
  {
    q: "What happens if I miss a Daily Boss Encounter?",
    a: "If an encounter is missed, your 'Practice Streak' will reset to zero unless you have a 'Streak Shield' active. Consistency is the primary metric for rank ascension."
  },
  {
    q: "How are badges earned and displayed?",
    a: "Badges are minted upon completion of high-level nodes or specific milestones (like a 7-day streak). Once earned, they appear in your 'Achievement Vault' located on the Profile page."
  },
  {
    q: "Does SkillQuest support team-based learning?",
    a: "Yes. The 'Leaderboard' module allows you to track your progress against a peer cohort, fostering competitive growth and collaborative problem-solving."
  },
  {
    q: "How can I contact technical support for the platform?",
    a: "SkillQuest is a conceptual demo developed by LingLink AI and DigLab AI. For production inquiries, please consult the lead architectural team at those respective labs."
  }
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="space-y-4 max-w-4xl mx-auto">
      {faqs.map((faq, idx) => (
        <div 
          key={idx} 
          className={`rounded-2xl border transition-all ${
            openIdx === idx ? 'bg-navy-900 border-navy-600' : 'bg-navy-950 border-navy-800'
          }`}
        >
          <button
            onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
            className="w-full text-left p-5 flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <SafeIcon icon={FiHelpCircle} className={openIdx === idx ? 'text-quest-500' : 'text-gray-600'} />
              <span className={`font-bold ${openIdx === idx ? 'text-white' : 'text-gray-400'}`}>{faq.q}</span>
            </div>
            <SafeIcon icon={openIdx === idx ? FiMinus : FiPlus} className="text-gray-500" />
          </button>
          
          <AnimatePresence>
            {openIdx === idx && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                className="overflow-hidden"
              >
                <div className="p-5 pt-0 text-gray-400 leading-relaxed border-t border-navy-800 mt-2">
                  <p className="pt-4">{faq.a}</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}